export class DocumentValidator {
    static isCPF(cpf: string): boolean {
      const cleanedCPF = cpf.replace(/\D/g, '');
  
      if (cleanedCPF.length !== 11 || /^(.)\1+$/.test(cleanedCPF)) {
        return false;
      }
  
      let sum = 0;
      let digit = 0;
  
      for (let i = 0; i < 9; i++) {
        sum += parseInt(cleanedCPF.charAt(i), 10) * (10 - i);
      }
  
      digit = (sum * 10) % 11;
      digit = digit === 10 ? 0 : digit;
  
      if (parseInt(cleanedCPF.charAt(9), 10) !== digit) {
        return false;
      }
  
      sum = 0;
  
      for (let i = 0; i < 10; i++) {
        sum += parseInt(cleanedCPF.charAt(i), 10) * (11 - i);
      }
  
      digit = (sum * 10) % 11;
      digit = digit === 10 ? 0 : digit;
  
      if (parseInt(cleanedCPF.charAt(10), 10) !== digit) {
        return false;
      }
  
      return true;
    }

  static formatCpfCnpj(doc: string): string {
    const digits = (doc || '').replace(/\D/g, '');
    if (digits.length === 11) {
      return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    if (digits.length === 14) {
      return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return doc;
  }

  }
